import { useContext } from "react";
import { Route } from "react-router-dom";
import { Private_Routes } from "../../constants";
import { HomePage, ProfilePage } from "../../pages/authenticated/private";
import { CreatePayrollNoveltyFlows } from "../../pages/payroll-novelty-flows/pages/CreatePayrollNoveltyFlows";
import { EditPayrollNoveltyFlows } from "../../pages/payroll-novelty-flows/pages/EditPayrollNoveltyFlows";
import PayrollNoveltyFlows from "../../pages/payroll-novelty-flows/pages/PayrollNoveltyFlows";
import { ManagePayrollNovelty } from "../../pages/payroll-novelty/pages/ManagePayrollNovelty";
import { RequestHistoryModal } from "../../pages/request-management/components/modals/RequestHistoryModal";
import { RequestManagement } from "../../pages/request-management/RequestManagement";
import { NotFoundRoutes } from "../../security";
import { AppContext } from "../context";
import Footer from "./Footer";
import Header from "./Header";
import { ManageBonus } from "../../pages/bonus/pages/ManageBonus";
import AuditLogsIndexPage from "../../pages/audit-logs/AuditLogsIndexPage";
import AuditLogDetailsPage from "../../pages/audit-logs/AuditLogDetailsPage";
import { OvertimeScheduleIndexPage } from "../../pages/overtime-schedule/pages/OvertimeScheduleIndexPage";

const SchedulingAuthenticatedLayout = () => {
  const { isRequestHistoryModalOpen } = useContext(AppContext);

  return (
    <>
      <Header />
      <NotFoundRoutes redirect={Private_Routes.HOME}>
        <Route path={Private_Routes.HOME} element={<HomePage />} />

        <Route
          path={Private_Routes.PAYROLL_NOVELTY_FLOWS.index}
          element={<PayrollNoveltyFlows />}
        />

        <Route
          path={Private_Routes.MANAGE_PAYROLL_NOVELTY.index}
          element={<ManagePayrollNovelty />}
        />

        <Route
          path={Private_Routes.MANAGE_BONUS.index}
          element={<ManageBonus />}
        />

        <Route
          path={Private_Routes.PAYROLL_NOVELTY_FLOWS.create}
          element={<CreatePayrollNoveltyFlows />}
        />

        <Route
          path={Private_Routes.PAYROLL_NOVELTY_FLOWS.edit}
          element={<EditPayrollNoveltyFlows />}
        />

        <Route path={Private_Routes.PROFILE} element={<ProfilePage />} />

        <Route
          path={Private_Routes.AUTHORIZE}
          element={<RequestManagement />}
        />

        <Route
          path={Private_Routes.AUDIT_LOGS.index}
          element={<AuditLogsIndexPage />}
        />

        <Route
          path={Private_Routes.AUDIT_LOGS.detail}
          element={<AuditLogDetailsPage />}
        />

        <Route
          path={Private_Routes.OVERTIME_SCHEDULE.index}
          element={<OvertimeScheduleIndexPage />}
        />
      </NotFoundRoutes>

      {isRequestHistoryModalOpen && <RequestHistoryModal />}

      <Footer />
    </>
  );
};

export default SchedulingAuthenticatedLayout;
